import * as React from 'react'
import { usePaywallStore, selectIsFreeTier } from './usePaywallStore'

function remainingOf(counter) {
    if (!counter || typeof counter.limit !== 'number') return null
    return Math.max(0, counter.limit - (counter.used || 0))
}

// Display-only view of the lifetime free-tier counters. `isFree` is the only
// gate the contextual surfaces need; a paid or unknown tier renders nothing.
export function useUsage() {
    const usage = usePaywallStore(state => state.usage)
    const usageStatus = usePaywallStore(state => state.usageStatus)
    const loadUsage = usePaywallStore(state => state.loadUsage)
    const isFree = usePaywallStore(selectIsFreeTier)

    React.useEffect(() => {
        if (usageStatus === 'idle') loadUsage()
    }, [usageStatus, loadUsage])

    return {
        usage,
        isFree,
        remaining: {
            graphs: remainingOf(usage?.graphsCreated),
            chats: remainingOf(usage?.chatsStarted),
        },
        reload: () => loadUsage(true),
    }
}
